import LoadingSpinner from "core/widgets/loadingSpinnerWidget";
import useInactivityHook from "core/hooks/useInactivity.hook";
import { Navigate, Outlet } from "react-router-dom";
import useGetUser from "hooks/user/useGetUser";
import { useStateContext } from "state";
import paths from "paths";

const PrivateLayout = () => {
  const portal = useInactivityHook();
  const state = useStateContext();
  useGetUser();

  return !state.tokens ? (
    <Navigate
      to={`/${paths.open.LOGIN}`}
      state={{ redirect: location.href }}
    />
  ) : (
    <>
      {!state.user ? (
        <LoadingSpinner />
      ) : (
        <>
          {portal}
          <Outlet />
        </>
      )}
    </>
  );
};

export default PrivateLayout;
